// extracted by mini-css-extract-plugin
module.exports = {"i5bkvuq":"i5bkvuq","b1govd7d":"b1govd7d"};